var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 17.5V10.95C16.8748 10.749 16.8263 10.5511 16.7335 10.3728C16.6407 10.1945 16.5064 10.0412 16.3419 9.92581L10.625 5.925V5H14.375V1.25H9.375V5.925L3.658 9.92644C3.49349 10.0418 3.35917 10.195 3.2664 10.3733C3.17363 10.5515 3.12513 10.7494 3.125 10.9503V17.5H1.25V18.75H18.75V17.5H16.875ZM10.625 2.5H13.125V3.75H10.625V2.5ZM4.375 10.9503L10 7.01281L15.625 10.9503V17.5H10.625V12.5H9.375V17.5H4.375V10.9503Z",
    fill: "#13BD7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/school-icon.d94c71e406fed322b94e97e2f86ec89d.svg";
export { ForwardRef as ReactComponent };